






















import { defineComponent, PropType } from '@nuxtjs/composition-api';
import { usePropSync } from '~/composables/usePropSync';

export default defineComponent({
  props: {
    tabs: {
      type: Array as PropType<string[]>,
      required: true,
    },
    tabIndex: {
      type: Number,
      default: 0,
    },
    isRanking: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const { syncedTabIndex } = usePropSync(props, 'tabIndex');

    const onChange = (index: number) => {
      syncedTabIndex.value = index;
    };

    return {
      syncedTabIndex,
      onChange,
    };
  },
});
